module.exports = __webpack_public_path__ + "img/search_gray.7082b04b.svg";